export default __webpack_public_path__ + "static/media/matic.7971305a.png";